




















import Vue, { PropType } from 'vue';
// export type DataType = {
//   style: any;
// }
export default Vue.extend({
  name: 'GAuthButton',
  props: {
    text: { type: String as PropType<string>, required: true },
    color: { type: String as PropType<string>, required: true },
    size: { type: String as PropType<string> },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    icon: { type: Boolean as PropType<boolean>, default: false },
  },
  methods: {
    onClick(): void {
      this.$emit('click');
    },
  },
});
